import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import logo from './logo.png';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
            ? "https://api.digassistant.xyz"
            : "http://localhost:8080";

const ManageSubscriptionPage = () => {
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [showPaymentFailedPopup, setShowPaymentFailedPopup] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchSubscriptionData();
        fetchUserEmail();
    }, []);

    const fetchUserEmail = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/check`, {
                credentials: "include",
            });

            if (response.ok) {
                const data = await response.json();
                if (data.email) {
                    setUserEmail(data.email);
                }
            }
        } catch (error) {
            console.error("Error fetching user email:", error);
        }
    };

    const fetchSubscriptionData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/billing/subscription/periodend?plan_type=check`, {
                credentials: "include",
            });

            if (response.ok) {
                const data = await response.json();
                // console.log('🔍 ManageSubscriptionPage: API response:', data);
                setSubscriptionData(data);

                // Check if payment failed and show popup
                if (data.payment_failed) {
                    setShowPaymentFailedPopup(true);
                }
            } else {
                setError("Failed to fetch membership information");
            }
        } catch (error) {
            console.error("Error fetching subscription data:", error);
            setError("Failed to fetch subscription information");
        } finally {
            setLoading(false);
        }
    };

    const handleRenew = async () => {
        setIsProcessing(true);
        try {
            const response = await fetch(`${API_BASE_URL}/billing/subscription/renew?plan_type=renew`, {
                method: "POST",
                credentials: "include",
            });

            if (response.ok) {
                const data = await response.json();
                const billingEndDate = data.subscription_period_end || data.end_date;

                alert(`Your membership has been renewed, you will be charged at the end of your previous billing period ${formatDate(billingEndDate)}`);

                // Redirect to service page
                navigate("/service");
            } else {
                alert("Failed to renew membership. Please try again.");
            }
        } catch (error) {
            console.error("Error renewing subscription:", error);
            alert("Failed to renew subscription. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    const handleCancel = () => {
        navigate("/cancel-confirmation");
    };

    const handleUpdatePaymentMethod = async () => {
        setIsProcessing(true);
        try {
            const response = await fetch(`${API_BASE_URL}/billing/customer/portal?plan_type=update_payment_method`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Failed to create portal session');
            }

            const data = await response.json();

            // Redirect to Stripe Customer Portal
            window.location.href = data.url;
        } catch (error) {
            console.error('Error opening customer portal:', error);
            alert('Failed to open payment method update. Please try again.');
            setIsProcessing(false);
        }
    };

    const handleGoBack = () => {
        navigate("/service");
    };

    const formatDate = (dateString) => {
        if (!dateString) return "Unknown";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/SQUASHJTTSCROWD.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: 0
                }}></div>
                <div className="App" style={{ position: 'relative', zIndex: 1 }}>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <a href="https://www.timehri.world/music" target="_blank" rel="noopener noreferrer">
                            <img src={logo} alt="Logo" className="logo" />
                        </a>
                        <div style={{
                            color: '#009e4a',
                            fontFamily: 'CustomFont',
                            fontSize: '13px',
                            marginTop: '10px'
                        }}>
                            Members
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        fontSize: '18px',
                        color: '#4CAF50'
                    }}>
                        Loading...
                    </div>
                </div>
            </div>
        );
    }

    const isCancelled = subscriptionData?.cancel_at_period_end;
    const periodEnd = subscriptionData?.subscription_period_end;

    return (
        <div style={{
            minHeight: '100vh',
            backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/SQUASHJTTSCROWD.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 0
            }}></div>
            <div className="App" style={{ position: 'relative', zIndex: 1 }}>
                <a href="https://www.timehri.world/music" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt="Logo" className="logo" />
                </a>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    maxWidth: '500px',
                    margin: '0 auto',
                    padding: '20px',
                    paddingTop: '120px',
                    textAlign: 'center'
                }}>
                    {error && (
                        <div style={{ color: 'red', marginBottom: '20px', fontFamily: 'CustomFont' }}>
                            {error}
                        </div>
                    )}

                    <div style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: '14px',
                        padding: '30px',
                        marginBottom: '30px',
                        fontFamily: 'CustomFont',
                        color: '#009e4a'
                    }}>
                        <p style={{ marginBottom: '20px', lineHeight: '1.5' }}>
                            Your membership{userEmail ? ` for ${userEmail}` : ''} {isCancelled ? 'is cancelled and will end on:' : 'renews on:'}
                        </p>
                        <p style={{
                            fontSize: '1.2em',
                            fontWeight: 'bold',
                            color: '#fcd117',
                            marginBottom: '20px'
                        }}>
                            {formatDate(periodEnd)}
                        </p>
                        <p style={{ fontSize: '0.9em', opacity: '0.8' }}>
                            {isCancelled
                                ? 'After this date, your account will revert to the free tier.'
                                : 'You will be charged for the next billing period on this date.'
                            }
                        </p>
                    </div>

                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                        <button
                            onClick={handleGoBack}
                            style={{
                                background: 'none',
                                border: '1px solid #009e4a',
                                color: '#009e4a',
                                padding: '12px 24px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontFamily: 'CustomFont',
                                fontSize: '16px',
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.background = '#009e4a';
                                e.target.style.color = 'black';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.background = 'none';
                                e.target.style.color = '#009e4a';
                            }}
                        >
                            Back to Service
                        </button>

                        <button
                            onClick={handleUpdatePaymentMethod}
                            disabled={isProcessing}
                            style={{
                                background: 'none',
                                border: '1px solid #009e4a',
                                color: '#009e4a',
                                padding: '12px 24px',
                                borderRadius: '5px',
                                cursor: isProcessing ? 'not-allowed' : 'pointer',
                                fontFamily: 'CustomFont',
                                fontSize: '16px',
                                opacity: isProcessing ? 0.6 : 1,
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => {
                                if (!isProcessing) {
                                    e.target.style.background = '#009e4a';
                                    e.target.style.color = 'black';
                                }
                            }}
                            onMouseOut={(e) => {
                                if (!isProcessing) {
                                    e.target.style.background = 'none';
                                    e.target.style.color = '#009e4a';
                                }
                            }}
                        >
                            {isProcessing ? 'Opening...' : 'Update Payment Method'}
                        </button>

                        {isCancelled ? (
                            <button
                                onClick={handleRenew}
                                disabled={isProcessing}
                                style={{
                                    background: 'none',
                                    border: '1px solid #009e4a',
                                    color: '#009e4a',
                                    padding: '12px 24px',
                                    borderRadius: '5px',
                                    cursor: isProcessing ? 'not-allowed' : 'pointer',
                                    fontFamily: 'CustomFont',
                                    fontSize: '16px',
                                    opacity: isProcessing ? 0.6 : 1,
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => {
                                    if (!isProcessing) {
                                        e.target.style.background = '#009e4a';
                                        e.target.style.color = 'black';
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (!isProcessing) {
                                        e.target.style.background = 'none';
                                        e.target.style.color = '#009e4a';
                                    }
                                }}
                            >
                                {isProcessing ? 'Renewing...' : 'Renew Membership'}
                            </button>
                        ) : (
                            <button
                                onClick={handleCancel}
                                style={{
                                    background: 'none',
                                    border: '1px solid #009e4a',
                                    color: '#009e4a',
                                    padding: '12px 24px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontFamily: 'CustomFont',
                                    fontSize: '16px',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.background = '#009e4a';
                                    e.target.style.color = 'black';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.background = 'none';
                                    e.target.style.color = '#009e4a';
                                }}
                            >
                                Cancel Membership
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Payment Failed Popup */}
            {showPaymentFailedPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        border: '2px solid #009e4a',
                        borderRadius: '14px',
                        padding: '30px',
                        maxWidth: '500px',
                        textAlign: 'center',
                        fontFamily: 'CustomFont',
                        color: '#009e4a',
                        position: 'relative'
                    }}>
                        <button
                            onClick={() => setShowPaymentFailedPopup(false)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                color: '#009e4a',
                                fontSize: '24px',
                                cursor: 'pointer',
                                fontFamily: 'CustomFont',
                                padding: '0',
                                width: '30px',
                                height: '30px',
                                lineHeight: '30px'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.color = '#fcd117';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.color = '#009e4a';
                            }}
                        >
                            ×
                        </button>
                        <h2 style={{ marginBottom: '20px', color: '#fcd117' }}>
                            Payment Failed
                        </h2>
                        <p style={{ marginBottom: '30px', lineHeight: '1.5' }}>
                            Your payment method failed. Please update your payment method to continue your membership.
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={handleUpdatePaymentMethod}
                                disabled={isProcessing}
                                style={{
                                    background: 'none',
                                    border: '1px solid #009e4a',
                                    color: '#009e4a',
                                    padding: '12px 24px',
                                    borderRadius: '5px',
                                    cursor: isProcessing ? 'not-allowed' : 'pointer',
                                    fontFamily: 'CustomFont',
                                    fontSize: '16px',
                                    opacity: isProcessing ? 0.6 : 1,
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => {
                                    if (!isProcessing) {
                                        e.target.style.background = '#009e4a';
                                        e.target.style.color = 'black';
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (!isProcessing) {
                                        e.target.style.background = 'none';
                                        e.target.style.color = '#009e4a';
                                    }
                                }}
                            >
                                {isProcessing ? 'Opening...' : 'Update Payment Method'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ManageSubscriptionPage;
